const REGEXP = {
  id: /^[a-zA-Z0-9!@#$%^&*?_~+=(){}.,;:-<>]{4,20}$/,
  password:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*?_~+=(){}.,;:-<>])[A-Za-z\d!@#$%^&*?_~+=(){}.,;:-<>]{8,}$/,
  number: /^[0-9]+$/,
  email:
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
};

export default REGEXP;
